import template from './footer.template.html';
import controller from './footer.controller';

const component = {
	bindings: {

	},
	template,
	controller,
	controllerAs: 'vm'
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/footer/components/footer/index.js